import { Component, DestroyRef, inject, OnInit, ViewChild, ViewContainerRef, ChangeDetectorRef, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { ActivatedRoute } from '@angular/router';
import { RouterSegments } from 'src/app/models/router-segments';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { RedirectionDialogComponent } from 'src/app/components/redirection-dialog/redirection-dialog.component';
import { RunbookService } from 'src/app/services/api/runbook.service';
import { RunbookPopupComponent } from '../../environment-runbook/runbook-popup/runbook-popup.component';
import { EnvScheduleService } from 'src/app/services/api/env-schedule.service';
import { EnvSchedulePopupComponent } from 'src/app/components/env-schedule-popup-component/env-schedule-popup-component';
import moment from 'moment';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ColumnFilterComponent } from 'src/app/main/instances-mgmt/column-filter/column-filter.component';
import { DatePipe } from '@angular/common';
import { UrlService } from 'src/app/services/util/url.service';
import { TenantService } from 'src/app/services/api/tenant.service';

@Component({
  selector: 'app-job-details',
  templateUrl: './environment-job-details.component.html',
  styleUrl: './environment-job-details.component.scss',
  standalone: false
})
export class EnvironmentJobDetails implements OnInit {
  @ViewChild('container', { read: ViewContainerRef }) container!: ViewContainerRef;
  @Input() instance: any;
  private destroyRef = inject(DestroyRef);
  isAzure = false;
  constructor(private dialog: MatDialog, private activatedRoute: ActivatedRoute, private router: Router,
    private toastrService: CustomToastrService, public authService: AuthService,
    private instanceService: InstancesService, private urlService: UrlService,
    private blueprintsService: BlueprintsService, private runbookService: RunbookService, private envScheduleService: EnvScheduleService, private cdr: ChangeDetectorRef, public sidenavService: SidenavService, public datePipe: DatePipe,
    private tenantService: TenantService) {

  }
  breadcrumbItems: BreadcrumbItem[];
  RouterSegments = RouterSegments;
  data: any
  dateCreated: any;
  tenantId: string;
  instanceId: string;
  jobName: string;
  job: string;
  redirectEnvironment: string;
  getBlueprints: any;
  runbookName: string;
  scheduleName: string;
  status: string;
  runbooks: any;
  matchedRunbook: any;
  matchedSchedule: any;
  schedules: any;
  isDetailsLoading = true;
  searchTerm: string = '';
  tableData: any;
  jobDetailsLoading = true;
  searchedResult = [];
  jobStatus: any;
  date:any;
  filterStartDate: any;
  filterEndDate: any;
  filteredColumns: any;
  isFiltered = false;
  clearData: boolean;
  selectedStatus = [];
  jobDetails: any;
  showLoader = false;
  jobId: any;
  cobDate: any;
  originalTableData: any;
  showTable = true;
  isRefreshing = false;
  adoPipelineUrl: string;
  buildPipelineUrl: string;

  inprogressStatus = ['inprogress', 'deleting', 'approving', 'deleting', 'rejecting', 'running', 'adding', 'removing', 'updating', 'preparing', 'promoting', 'creating', 'deploying', 'started'];
  failedStatus = ['failed', 'approval_failed', 'rejection_failed','Failed', 'preparation_failed', 'promotion_failed'];
  completedStatus = ['completed', 'published', 'approved', 'active', 'added', 'updated','success','Success', 'prepared', 'promoted', 'deployed'];
  expiredStatus = ['expired'];
  deletedStatus = ['deleted'];
  deleteFailedStatus = ['delete_failed'];

  dropdownsList: any = [{ options: [] }];
  displayColumns = [
  {
      key: 'timeline',
      name: '',
      type: 'timeline',
      sortable: true,
      visible: true
    },
    {
      key: 'stageName',
      name: 'JOBS.STAGE_NAME',
      type: 'text',
      sortable: true,
      visible: true
    },
    {
      key: 'startTime',
      name: 'JOBS.START_TIME',
      type: 'date',
      sortable: true,
      visible: true
    },
    {
      key: 'endTime',
      name: 'JOBS.END_TIME',
      type: 'date',
      visible: true,
      sortable: true
    },
    {
      key: 'duration',
      name: 'JOBS.DURATION',
      type: 'text',
      visible: true,
      sortable: true,
      startKey: 'startTime',
      endKey:'endTime',
    },
    {
      key: 'status',
      name: 'JOBS.STATUS',
      type: 'status',
      sortable: true,
      visible: true,
      statusKey: 'statuskey'
    },
    {
      key: 'download',
      name: '',
      type: 'download',
      sortable: false,
      visible: true
    }
  ];

  statusIconMap: Record<string, string> = {};



  ngOnInit(): void {
    this.breadcrumbItems = [];
    this.instanceId = this.activatedRoute.snapshot.params.instanceId;
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.jobName = history.state?.job?.jobName;
    this.runbookName = history.state?.job?.runbookName;
    this.scheduleName = history.state?.job?.scheduleName;
    this.status = history.state?.job?.status;
    this.jobId = this.activatedRoute.snapshot.params.jobId;
    this.tenantService.getTenantDetails(this.tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(tenant => {
        this.isAzure = (tenant?.cloudProvider || tenant?.targetCloud || '').toLowerCase() === 'azure';
      });
    if (localStorage.getItem('filteredEnvJobDetailStatus')) {
        const userData = JSON.parse(localStorage.getItem('filteredEnvJobDetailStatus'));
        if (userData) {
          this.selectedStatus = userData;
          this.jobStatus = this.selectedStatus;
          this.dropdownsList?.[0]?.options?.forEach(element => {
            if(this.selectedStatus.find(item=> item === element.value)) {
              element.selected = true;
            }
          });
        }
      }
    this.getInstanceDetails(this.instanceId);
    this.getRunbooks();
    this.fetchSchedule();
    this.buildStatusIconMap();
    this.getjobdetailsByid();
  }

  getjobdetailsByid() {
    this.showLoader = true;
    this.envScheduleService.getInstanceJobsById(this.instanceId, this.jobId)
    .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(response => {
          this.jobDetails = response;
          this.status = this.jobDetails.status;
          const stepWithCobDate = response.steps?.[0];
          if (stepWithCobDate?.details) {
          const raw = stepWithCobDate.details.cobDate || null;
          this.cobDate = raw ? moment(raw, "YYYYMMDD").toDate() : null;
          }
          this.prepareStageTable(this.jobDetails);
          this.isDetailsLoading = false;
          this.showLoader = false;
          this.initializeFilterItems();
        },
         (error) => {
          this.isDetailsLoading = false;
          this.showLoader = false;
          this.initializeFilterItems();
          setTimeout(() => {
            const title = translate('ERRORS.SERVICE_AVAILABILITY');
            const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
            this.toastrService.errMessage(message, title);
          }, 500);
        });
  }

  prepareStageTable(data: any) {
  this.initializeFilterItems();
  this.jobDetailsLoading = false;
  if (!data?.steps) return;

  const existingStepNames = new Set<string>();
  const missingNextSteps: any[] = [];

  this.tableData = data.steps.map((step, idx) => {
    existingStepNames.add(step.name);

    return {
      index: idx,
      stageName: step.displayName || step.name,
      startTime: step.startTime ? new Date(step.startTime) : null,
      endTime: step.endTime ? new Date(step.endTime) : null,
      duration: (step.startTime ? new Date(step.startTime) : null) && (step.endTime ? new Date(step.endTime) : null) ? this.getDuration(step.startTime ? new Date(step.startTime) : null, step.endTime ? new Date(step.endTime) : null) : '-',
      status: step.status,
      statuskey: true,
      reportFile: step.reportFile,
      errors: step.errors,
      jobId: data.id,
      scheduleId: data.scheduleId,
      runbookId: data.runbookId,
    };
  });

  data.steps.forEach(step => {
    if (step.nextStep && !existingStepNames.has(step.nextStep)) {
      missingNextSteps.push({
        index: this.tableData.length + missingNextSteps.length,
        stageName: step.nextStep,
        startTime: null,
        endTime: null,
        duration: '-',
        status: 'yet to start',
        statuskey: true,
        reportFile: '',
        errors: null,
        jobId: data.id,
        scheduleId: data.scheduleId,
        runbookId: data.runbookId,
      });

      existingStepNames.add(step.nextStep);
    }
  });

  this.tableData = [...this.tableData, ...missingNextSteps];
  this.originalTableData = [...this.tableData];
}


getDuration(start: Date, end: Date) {
  if (!start || !end) {
    return '-';
  }

  const diffMs = end.getTime() - start.getTime();

  if (diffMs <= 0) {
    return '0 Secs';
  }

  const totalSeconds = Math.floor(diffMs / 1000);
  const mins = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;

  if (mins > 0 && secs > 0) {
    return `${mins} Mins ${secs} Secs`;
  }

  if (mins > 0) {
    return `${mins} Mins`;
  }

  return `${secs} Secs`;
}

  loadService(): void {
    const blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    this.blueprintsService.getBlueprints(this.data?.tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((blueprints: any) => {
        this.getBlueprints = blueprints?.find(item => item.id == blueprintId);
        this.breadcrumbItems = [
          { icon: 'assets/images/home_icon.svg', url: [RouterSegments.TENANT, this.tenantId] },
          { label: translate('TENANT_LAYOUT.MENU.SERVICE_DEFINITION'), url: [RouterSegments.TENANT, this.tenantId, RouterSegments.SERVICE_DEFINITION] },
          { label: this.getBlueprints?.name, url: [RouterSegments.TENANT, this.tenantId, RouterSegments.BLUEPRINTS, this.getBlueprints?.id] },
          { label: this.data.name, url: [RouterSegments.TENANT, this.tenantId, RouterSegments.BLUEPRINTS, this.getBlueprints?.id, RouterSegments.ENVIRONMENT, this.instanceId] },
          { label: translate('JOBS.JOB'), action: () => this.goToJobs()},
          { label: this.jobName }
        ];
        this.isDetailsLoading = false;
      });
  }

   getRunbooks(): void {
    this.runbookService.getRunbook(this.activatedRoute.snapshot.params.instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(runbooks => {
        this.runbooks = runbooks;
         this.matchedRunbook = runbooks.find(
        (rb: any) => rb.name?.toLowerCase() === this.runbookName?.toLowerCase()
      );
      this.isDetailsLoading = false;
      
      },
      (error) => {
        setTimeout(() => {
          this.isDetailsLoading = false;
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  fetchSchedule(): void {
  this.envScheduleService.getSchedule(this.instanceId)
  .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(response => {
          this.schedules = response;
          this.matchedSchedule = response.find(
        (schedule: any) => schedule.name?.toLowerCase() === this.scheduleName?.toLowerCase());
        this.isDetailsLoading = false;
        },
         (error) => {
          setTimeout(() => {
            const title = translate('ERRORS.SERVICE_AVAILABILITY');
            const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
            this.toastrService.errMessage(message, title);
          }, 500);
        });
    }

runbookPopup() { 
      if(this.matchedRunbook) {   
      this.dialog.open(RunbookPopupComponent, {
      width: '800px',
      panelClass: 'default-dialog-wrapper',
      data: {
        runbook: this.matchedRunbook,
        name: this.data?.name
      }
    });
   }
  }

  schedulePopup(): void {
       this.dialog.open(EnvSchedulePopupComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '778px',
        height: '449px',
        autoFocus: false,
        data: {
          value: this.matchedSchedule,
          instanceId: this.activatedRoute.snapshot.params.instanceId
        }
      });
    }

  getInstanceDetails(instanceId): void {
    this.instanceService.getInstanceDetails(instanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.data = data;
          this.dateCreated = this.data?.dateCreated;
          
          this.loadService();
          this.setNavigationUrl();
        }
      },
        (error) => {
          setTimeout(() => {
            const title = translate('ERRORS.SERVICE_AVAILABILITY');
            const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
            this.toastrService.errMessage(message, title);
          }, 500);
        });
  }

  getConfirmation(): void {
    this.dialog.open(RedirectionDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        proceedButtonText: translate('BUTTONS.PROCEED'),
        redirectTitle: translate('JOBS.TEMN_MONITOR'),
        redirectMsg: translate('JOBS.TEMN_MONITOR_DASHBOARD')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm)
          window.open(this.redirectEnvironment, '_blank');
      })
  }

  goToJobs(): void {
    const tenantId = this.activatedRoute.snapshot.params.id;
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT , tenantId, RouterSegments.BLUEPRINTS, this.activatedRoute.snapshot.params.blueprintId,
      RouterSegments.ENVIRONMENT, this.activatedRoute.snapshot.params.instanceId], {state: {data: 'JOBS'}});
  }

  refreshClick(): void {
    this.isRefreshing = true;
    this.jobDetailsLoading = true;
    setTimeout(() => {
      this.isRefreshing = false;
      this.jobDetailsLoading = false;
      this.getjobdetailsByid();
    }, 1000);
    return;
}

  search(searchTerm?: string): void {
    this.searchTerm = searchTerm;
  }

  initializeFilterItems(){
        this.jobStatus = [
        {value: 'completed', label: "Completed",selected: false},
        {value: 'started', label: "Started",selected: false},
        {value: 'running', label: "Running",selected: false},
        {value: 'failed', label: "Failed",selected: false}
      ];
  
      this.dropdownsList = [
        {
          title: 'Status',
          placeholder: 'Select Status',
          options: this.jobStatus
        }
      ];
  }

  filterColumns(): void {
   if(this.jobStatus) {
        this.dropdownsList[0].options.filter((item) => {
          if (this.jobStatus?.find(status => status === item.value)) {
            item.selected = true;
          }
        });
      }
      const data = {
        name: translate('JOBS.JOB_DETAILS'),
        title: translate('INSTANCE_STATUS.FILTER_TITLE'),
        subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
        filteredColumns: this.dropdownsList,
        dateCreated: this.dateCreated,
        envJobDetailStatusList: this.dropdownsList?.[0].options,
        envJobDetailColumns: [
          'status'
        ]
      };
      this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(filteredColumns => {
        this.filteredColumns = filteredColumns;
        if (filteredColumns) {
          this.isFiltered = true;
          this.clearData = true;
          if(filteredColumns[0] !== '') {
            this.jobStatus = filteredColumns[0];
          }
           if (filteredColumns[0]?.length === 0){
            this.resetJobDetailFilter();
          } else {
            this.filterJobDetailItems(filteredColumns);
          }
        }
      });
  }

  /* Filters the Runbook table data based on the selected filter criteria. */
    filterJobDetailItems(filteredColumns): void {
       if (!filteredColumns || !filteredColumns[0]?.length) {
    this.tableData = [...this.originalTableData];
  } else {
    this.selectedStatus = filteredColumns[0];

    this.tableData = this.originalTableData.filter(row => {
      const status = row.status?.toLowerCase();

      return this.selectedStatus.some(filter => {
        if (filter === 'completed') {
          return this.completedStatus.includes(status);
        }
        if (filter === 'failed') {
          return this.failedStatus.includes(status);
        }
        if (filter === 'running') {
          return this.inprogressStatus.includes(status);
        }
        if (filter === 'started') {
          return status === 'started';
        }
        return false;
      });
    });
  }
  this.showTable = false;
  setTimeout(() => this.showTable = true);
}

     /* Cleares the selected Status filter */
    cancelStatusFilter(data) {
      let selectedItem = this.selectedStatus.indexOf(data);
      if (selectedItem > -1) {
        localStorage.removeItem('filteredEnvJobDetailStatus');
        this.selectedStatus.splice(selectedItem, 1);
        this.dropdownsList[0].options.find(item => item.value === data).selected = false;
        localStorage.setItem('filteredEnvJobDetailStatus', JSON.stringify(this.selectedStatus));
        this.filterJobDetailItems(this.filteredColumns);
      }
    }

  /* Reset the selected filter */
    resetJobDetailFilter(): void {
      this.isFiltered = false;
      this.selectedStatus = [];
      this.sidenavService.searchFilter.next('data');
      this.dropdownsList?.[0]?.options.filter((item) => {item.selected = false});
      this.jobStatus = undefined;
      this.tableData = [...this.originalTableData];
      localStorage.removeItem('filteredEnvJobDetailCustomDate');
      localStorage.removeItem('filteredEnvJobDetailStatus');
    }

buildStatusIconMap(): void {
  this.mapStatusList(this.completedStatus, 'check_circle_filled');
  this.mapStatusList(this.failedStatus, 'cancel_filled');
  this.mapStatusList(this.expiredStatus, 'do_not_disturb_on');
  this.mapStatusList(this.deletedStatus, 'delete');
  this.mapStatusList(this.deleteFailedStatus, 'delete_forever');
}

searchedItems(result): void {
    this.searchedResult = result;
    this.cdr.detectChanges();
}

private mapStatusList(list: string[], icon: string): void {
  list.forEach(status => {
    this.statusIconMap[status.toLowerCase()] = icon;
  });
}

getStatusIcon(status: string): string {
  if (!status) return '';
  return this.statusIconMap[status.toLowerCase()] || '';
}

getStatusLabel(status: string): string {
  if (!status) return '';
  const customLabels: any = {
    running: 'Running',
    deployed: 'Deployed',
    inprogress: 'Inprogress',
    failed: 'Failed',
    completed: "Completed",
    created: "Created"
  };
  return customLabels[status] || this.titlecase(status);
}


 
    /* Returns a label for the Status */
    getJobStatusLabel(status): void {
      // return this.scheduleStatus?.find(item=> item.value === status).label;
          return this.selectedStatus?.find(item => item.value === status)?.label || status || '';
    }
titlecase(str: string): string {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

isInProgress(status: string): boolean {
  return this.inprogressStatus.includes(status);
}

  setNavigationUrl() {
    var currentEnv = window.location.href.split('.')[0].split('/')[2]
    this.redirectEnvironment = (currentEnv === 'preprod' || currentEnv === 'utp' || currentEnv === 'dev' || currentEnv === 'sbx') 
        ? `https://temn-pre.monitor.saas.temenos.cloud/grafana/d/GVATEQ57z1/cob-summary?orgId=1&from=now-7d&to=now&timezone=browser&var-client=${this.tenantId}&var-env=${this.data.randomSuffix}-${this.data.name}&var-Servicename=COB&var-adhoc=` 
        : `https://temn-uk.monitor.saas.temenos.cloud/grafana/d/GVATEQ57z1/cob-summary?orgId=1&from=now-5m&to=now&timezone=browser&var-client=${this.tenantId}&var-env=${this.data.randomSuffix}-${this.data.name}&var-Servicename=COB&var-adhoc=`;
  }

  buildRunbookAdoUrl(): void {
    const pipelineId = this.matchedRunbook?.targets?.primary?.targetADOPipeline?.pipelineId || '';
    this.adoPipelineUrl = this.urlService.buildADOPipelineUrl(pipelineId);
  }

  buildJobResultsUrl(): void {
    const buildId = this.jobId || '';
    this.buildPipelineUrl = this.urlService.buildJobResultsUrl(buildId);
  }

  redirectADO(): void {
    this.buildRunbookAdoUrl();
    if (this.adoPipelineUrl) {
      const dialogData = {
        redirectTitle: translate('ADD_INSTANCE.ADO_PIPELINE'),
        redirectMsg: translate('INSTANCE_DETAILS.ADO_PIPELINE'),
        proceedButtonText: translate('BUTTONS.PROCEED')
      };
      this.dialog.open(RedirectionDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: dialogData,
        disableClose: false
      }).afterClosed().subscribe(result => {
        if (result) {
          window.open(this.adoPipelineUrl, '_blank');
        }
      });
    }
  }

  redirectBuildPipeline(): void {
    this.buildJobResultsUrl();
    if (this.buildPipelineUrl) {
      const dialogData = {
        redirectTitle: translate('ADD_INSTANCE.BUILD_PIPELINE'),
        redirectMsg: translate('INSTANCE_DETAILS.BUILD_PIPELINE'),
        proceedButtonText: translate('BUTTONS.PROCEED')
      };
      this.dialog.open(RedirectionDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: dialogData,
        disableClose: false
      }).afterClosed().subscribe(result => {
        if (result) {
          window.open(this.buildPipelineUrl, '_blank');
        }
      });
    }
  }

}
